import { render, staticRenderFns } from "./NullifiedServices.vue?vue&type=template&id=49315546"
import script from "./NullifiedServices.vue?vue&type=script&lang=js"
export * from "./NullifiedServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports